import { render, staticRenderFns } from "./StudentEvaluationForm.vue?vue&type=template&id=2f8d7794&"
import script from "./StudentEvaluationForm.vue?vue&type=script&lang=js&"
export * from "./StudentEvaluationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports